import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Button } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import DownArrow from '@/assets/arrow_down.svg';
import UncheckedBox from '@/assets/unchecked-box.svg';
import CheckedBox from '@/assets/checked-box.svg';
import FlexBox from '@/atomic-components/FlexBox';
import { useEffect, useState } from 'react';

export type FilterTileData = {
	label: string;
	options: Option[];
	value: string;
};

export interface Option {
	count?: number;
	label: string;
}

type FilterTileProps = {
	data: FilterTileData;
	preSelectedFilters: { key: string; val: string }[] | undefined;
	onFilterConfirm: (selectedFilters: { key: string; val: string }[]) => void;
};

function FiltersTile(props: FilterTileProps) {
	const { data } = props;
	const [filterOptionsOpen, setFilterOptionsOpen] = useState(false);
	const [selectedFilters, setSelectedFilters] = useState<
		{ key: string; val: string }[]
	>(props.preSelectedFilters?props.preSelectedFilters : []);
	useEffect(()=>{
		setSelectedFilters(props.preSelectedFilters?props.preSelectedFilters : [])
	},[props.preSelectedFilters])
	const onFilterSelect = (key: string, val: string) => {
		let filterData;
		if (selectedFilters.find((x: any) => x.val == val)) {
			filterData = selectedFilters.filter((x: any) => {
				return x.val != val;
			});
			setSelectedFilters(filterData);
		} else {
			setSelectedFilters([...selectedFilters, { key: key, val: val }]);
		}
	};
	return (
		<Box
			sx={{
				position: 'relative',
				padding: '8px 16px',
				border: `1px solid ${getColor('Gray -2')}`,
				margin: '8px',
				borderRadius: '24px',
				maxHeight:'38px',
				whiteSpace: 'nowrap',
				'.dropdown-Content':{
					opacity:0,
					pt:1,
					zIndex:-1
				},
				'&:hover':{
					'.dropdown-Content':{
						opacity:1,
						position:'absolute',
						zIndex:7,
						padding:'16px 0',
						height:'max-content'
					}
				}
			}}
		>
			<FlexBox sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
				<LencoTypography
					sx={{
						...getStyle('Small_Medium'),
						color: getColor('Gray -2'),
						marginRight: '140px',
					}}
				>
					{data?.label}
				</LencoTypography>
				{data?.options?.length > 1 && <DownArrow />}
			</FlexBox>

			<Box
				className='dropdown-Content'
				sx={{
					boxShadow:'0px 8px 16px rgba(34, 34, 34, 0.1);',
					width:'100%',
					transition:'0.3s all ease-in',
					left: 0,
					background: getColor(''),
					border: `1px solid ${getColor('Minty 0')}`,
					borderRadius: '24px',
					padding:'0px 0',
					top:'40px',
					height:'0px',
					overflow:'hidden'
				}}
				
			>
				<Box sx={{ maxHeight: '392px', overflow: 'scroll' }}>
					{props?.data?.options?.map((filterOps) => {
						const isFilterSelected =
							selectedFilters &&
							selectedFilters.find(
								(element: any) => element?.val == filterOps?.label
							);

						return (
							<Box
								
								key={filterOps.label}
								sx={{
									padding: '0 20px',
									color: getColor('Gray -1'),
									'&:hover': {
										background: getColor('Minty -6'),
										transition: 'background 0.5s ease',
										color:getColor('Minty 0')
									},
								}}
								onClick={() => {
									onFilterSelect(data.value, filterOps.label);
								}}
							>
								<FlexBox
									sx={{
										padding:'8px 0',
										justifyContent: 'space-between',
										alignItems: 'center',
										borderBottom: `1px solid ${getColor('Minty -3')}`,
										
									}}
									onClick={() => {}}
								>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											marginRight: '8px',
										}}
									>
										{filterOps.label}
									</LencoTypography>
									{isFilterSelected ? <CheckedBox /> : <UncheckedBox/>}
								</FlexBox>
							</Box>
						);
					})}
				</Box>
				<Box sx={{padding:'0 16px'}}>
				<Button
					fullWidth
					sx={{
						background: getColor(''),
						border: `1px solid ${getColor('Gray -2')}`,
						marginTop: '24px',
						color: getColor('Gray -2'),
						borderRadius: '24px',
					}}
					onClick={() => props.onFilterConfirm(selectedFilters)}
				>
					Confirm
				</Button>
				</Box>
				
			</Box>
		</Box>
	);
}

export default FiltersTile;
